<fm-tabs [paddingOffset]="12" [shouldFitTabs]="true" (activeChanged)="onTabChange()">
  <fmTab
    [active]="activeTab === EVehicleDriverPanelTabs.VehicleList"
    [shouldDestroyOnDeactivation]="true"
    id="btn-vehicle-list"
    ariaLabelTranslation="@@S_REPORT_SETTINGS_FLEET_SELECTION"
    ariaLabelName="Fleet Selection"
    (selected)="selectTab(EVehicleDriverPanelTabs.VehicleList)"
  >
    <ng-template fmTabHeading let-tab>
      <mat-icon
        svgIcon="ic-tree"
        class="vehicle-driver-panel-large__header-image mat-icon-size-special"
        i18n-fmTooltip="@@S_REPORT_SETTINGS_FLEET_SELECTION"
        fmTooltip="Fleet Selection"
        [class.vehicle-driver-panel-large__header-image--active]="tab.active"
      ></mat-icon>
    </ng-template>
    <ng-template fmTabContent>
      <fm-vehicle-selection-panel
        [maxPlottableVehicles]="maxPlottableVehicles"
        [selectionMode]="vehicleSelectionMode"
        [vehicleListScopingTreeData]="vehicleListScopingTreeData"
        [vehicleListTreeData]="vehicleListTreeData"
        [isVehicleScopingEnabled]="isVehicleScopingEnabled"
        [isAssetsEnabled]="isAssetsEnabled"
        [anyPoweredAssets]="anyPoweredAssets"
        [anyNonPoweredAssets]="anyNonPoweredAssets"
        (editScopingClick)="onVehicleListEditScopingClick($event)"
        (selectionChange)="onVehicleListSelectionChange($event)"
        (selectionModeChange)="onVehicleListSelectionModeChange($event)"
        (vehicleClick)="onVehicleListSelectFocusVehicle($event)"
        (vehicleRightClick)="onVehicleListSelectionRightClick($event)"
        (vehicleListScopingClose)="onVehicleListScopingClose()"
        (vehicleListScopingSave)="onVehicleListScopingSave($event)"
      ></fm-vehicle-selection-panel>
    </ng-template>
  </fmTab>
  <fmTab
    [active]="activeTab === EVehicleDriverPanelTabs.VehicleStatus"
    id="btn-vehicle-status"
    ariaLabelTranslation="@@S_RP_FLEETSTATUS"
    ariaLabelName="Fleet Status"
    (selected)="selectTab(EVehicleDriverPanelTabs.VehicleStatus)"
  >
    <ng-template fmTabHeading let-tab>
      <mat-icon
        svgIcon="ic-vehicle"
        class="vehicle-driver-panel-large__header-image mat-icon-size-special"
        i18n-fmTooltip="@@S_RP_FLEETSTATUS"
        fmTooltip="Fleet Status"
        [class.vehicle-driver-panel-large__header-image--active]="tab.active"
      ></mat-icon>
    </ng-template>
    <ng-template fmTabContent>
      <div class="vehicle-driver-panel_status-tab-content-container" [class.status-panel-ready]="isStatusPanelReady">
        <div
          class="vehicle-driver-panel-sort"
          *ngIf="hasFleetConnected && isStatusPlotsLoaded && (hasFleetSelected || selectedAttributes().length > 0)"
        >
          <div class="vehicle-driver-panel-sort__filters">
            <div class="vehicle-driver-panel-large__dropdown">
              <fm-status-sort-options
                [vehicleSortTypeSelected]="vehicleSortTypeSelected"
                (sortParamChanged)="onSortParamChange($event)"
              ></fm-status-sort-options>
              <fm-status-filter-options
                [showSkeleton]="attributeFiltering()"
                a7s-id="vehicle-driver-panel-status-filter"
                (statusFilterChanged)="onStatusFilterChange($event)"
                [statusFilterSelected]="statusFilterSelected"
                [statusCounts]="statusFilterCounts"
              ></fm-status-filter-options>
            </div>
            @if(isAttributeFilterEnabled()) {
            <fm-attribute-filter
              [showSkeleton]="attributeFiltering()"
              [containerRef]="elementRef"
              [attributeItems]="attributeItems()"
              [loading]="attributeLoading()"
              [error]="attributeError()"
              [selectedAttributes]="selectedAttributes()"
              (filterApplied)="filterApplied.emit($event)"
              (refreshClicked)="refreshClicked.emit()"
            ></fm-attribute-filter>
            }
            <div>
              @if(attributeFiltering()) {
              <div class="skeleton-circle"></div>
              } @else {
              <button
                class="vehicle-driver-panel-sort__button"
                mat-icon-button
                (click)="openVehicleDriverSortPanel()"
                [attr.a7s-id]="isChargeableEVInFleet ? 'live-map-vehicle-panel-chargeable-ev-in-fleet' : null"
              >
                <mat-icon
                  svgIcon="ic-sort"
                  class="mat-icon-size-xs line-height-xs"
                  i18n-fmTooltip="@@S_TRACKABLES_LIST_MOBILE_SORT_BY"
                  fmTooltip="Sort by"
                  a7s-id="live-map-selection-panel-sort-by"
                >
                </mat-icon>
              </button>
              }
            </div>
          </div>
          @if((isAttributeFilterEnabled())) {
          <fm-attribute-chips
            [selectedAttributes]="selectedAttributes()"
            [showSkeleton]="attributeFiltering()"
            (chipRemoved)="chipRemoved.emit($event)"
            (overflowClicked)="attributeFilterComponent()?.toggleFilter()"
          ></fm-attribute-chips>
          }
        </div>
        <fm-vehicle-status
          [ngClass]="{ 'vehicle-status__no-status-filter': !hasFleetConnected || !hasFleetSelected || !isStatusPlotsLoaded }"
          [hasFleetConnected]="hasFleetConnected"
          [hasFleetSelected]="hasFleetSelected"
          [isStatusPlotsLoaded]="isStatusPlotsLoaded"
          [itemToScrollTo]="itemToScrollTo"
          [isPingMVPEnabled]="isPingMVPEnabled"
          [showSkeleton]="attributeFiltering()"
        >
        </fm-vehicle-status>
      </div>
    </ng-template>
  </fmTab>
  <fmTab
    [active]="activeTab === EVehicleDriverPanelTabs.DriverStatus"
    [visible]="showTachoInformation"
    id="btn-driver-list"
    ariaLabelTranslation="@@S_DRIVERSTATUS"
    ariaLabelName="Driver Status"
    (selected)="selectTab(EVehicleDriverPanelTabs.DriverStatus)"
  >
    <ng-template fmTabHeading let-tab>
      <mat-icon
        svgIcon="ic-driver"
        class="driver-status-panel-large__header-image mat-icon-size-special"
        i18n-fmTooltip="@@S_DRIVERSTATUS"
        fmTooltip="Driver Status"
        [class.driver-list-panel-large__header-image--active]="tab.active"
      ></mat-icon>
    </ng-template>
    <ng-template fmTabContent>
      <fm-driver-status-panel
        [driverStatusData]="driverStatusData"
        [driverStatusFilter]="driverStatusFilter"
        [isDriverBreakDueFilterSelected]="isDriverBreakDueFilterSelected"
        [driverStatusSortType]="driverStatusSortType"
        [isDriverPlannerPageAllowed]="isDriverPlannerPageAllowed"
        (filterChange)="onFilterChange($event)"
        (driverBreakDueFilterChanged)="onDriverBreakDueFilterSelectedChange($event)"
        (driverStatusSortTypeChanged)="onStatusSortTypeChange($event)"
        (selectVehiclesClicked)="selectTab(EVehicleDriverPanelTabs.VehicleList)"
        (highlightMarker)="onHighlightMarker($event)"
        (removeMarkerHighlight)="onRemoveMarkerHighlight()"
        (openDriverStatusContextMenu)="onOpenDriverStatusContextMenu($event)"
        (triggerZoomTo)="zoomToPosition($event)"
        (openDriverPlanner)="onOpenDriverPlanner()"
      >
      </fm-driver-status-panel>
    </ng-template>
  </fmTab>
</fm-tabs>
<span
  *ngIf="isPanelCollapsed; else panelExpanded"
  id="btn-vehicle-driver-panel-expander"
  class="vehicle-driver-panel-large__expander vehicle-driver-panel-large__expander--collapsed"
  a7s-id="live-map-selection-panel-expand"
  i18n-aria-label="@@S_VEHICLE_PANEL_EXPAND_PANEL"
  aria-label="Expand Panel"
  i18n-fmTooltip="@@S_VEHICLE_PANEL_EXPAND_PANEL"
  fmTooltip="Expand Panel"
  (click)="toggleIsCollapsed()"
>
</span>

<ng-template #panelExpanded>
  <span
    id="btn-vehicle-driver-panel-expander"
    class="vehicle-driver-panel-large__expander"
    a7s-id="live-map-selection-panel-collapse"
    i18n-aria-label="@@S_VEHICLE_PANEL_COLLAPSE_PANEL"
    aria-label="Collapse Panel"
    i18n-fmTooltip="@@S_VEHICLE_PANEL_COLLAPSE_PANEL"
    fmTooltip="Collapse Panel"
    (click)="toggleIsCollapsed()"
  >
  </span>
</ng-template>
